import conf from '../config';
import { getOrganization } from './users';

const initialState = {
  tags: [],
};

const SET_TAGS = 'SET_TAGS';
const ADD_TAG = 'ADD_TAG';
const DELETE_TAGS = 'DELETE_TAGS';
const CLEAR_DATA = 'CLEAR_DATA'

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TAGS:
      return { ...state, tags: action.payload };
    case ADD_TAG:
      const tags = state.tags;
      tags.push([
        { label: `${action.payload.name} (0)`, value: action.payload.name },
      ]);
      return { ...state, tags };
    case DELETE_TAGS:
      const oldTags = state.tags;
      const toDelete = action.payload.reduce((acc, el) => {
        acc[el] = true;
        return acc;
      }, {});
      const newTags = oldTags.filter(v => !toDelete[v[0] && v[0].value]);
      return { ...state, tags: newTags };
    case CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
};

const addTag = tag => ({ type: ADD_TAG, payload: tag });
const setTags = tags => ({ type: SET_TAGS, payload: tags });
const deleteTags = tags => ({ type: DELETE_TAGS, payload: tags });

export const getTags = state => state.tags.tags;

export const fetchTags = () => async (dispatch, getState) => {
  const state = getState();
  const tags = getTags(state);
  if (tags.length) return tags;
  const organization = getOrganization(state);
  const request = await fetch(
    `${conf.apiRoot}/api/tags?organization=${organization &&
      organization.slug}`,
    {
      credentials: 'include',
    }
  ).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (request) {
    const tags = request.map(v => [
      { label: `${v.name} (${v.count})`, value: v.name },
    ]);
    tags.sort((a, b) =>
      a[0].value.replace(/\s|\n/g, '') > b[0].value.replace(/\s|\n/g, '')
        ? 1
        : -1
    );
    dispatch(setTags(tags));
  }
  return request;
};

export const createTag = name => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  const request = await fetch(`${conf.apiRoot}/api/tags`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name,
      organization: organization && organization.slug,
    }),
  }).then(res => {
    if (res.status === 200 || res.status === 422) return res.json();
    return null;
  });
  if (request && request.status === 'ok') {
    dispatch(addTag(request.model));
  }
  return request;
};

export const deleteTag = tags => async (dispatch, getState) => {
  const state = getState();
  const organization = getOrganization(state);
  const request = await fetch(`${conf.apiRoot}/api/tags/delete`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      tags,
      organization: organization && organization.slug,
    }),
  }).then(res => res.json());
  if (request && request.status === 'ok') {
    dispatch(deleteTags(tags));
  }
  return request;
};



// WEBPACK FOOTER //
// ./src/modules/tags.js